import { render, staticRenderFns } from "./StudentDashboardNavbar.vue?vue&type=template&id=0ea1f154&scoped=true&"
import script from "./StudentDashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./StudentDashboardNavbar.vue?vue&type=script&lang=js&"
import style0 from "./StudentDashboardNavbar.vue?vue&type=style&index=0&id=0ea1f154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1f154",
  null
  
)

export default component.exports